import React from "react";
import { Outlet } from "react-router-dom";

import { useOrder } from "../../contexts/OrderContext";

import { Navigate } from "react-router-dom";
import Loader from "../commonComponents/Loader/Loader";

export default function PlaceSelector() {
  const { getLength, isInFetch, isInProcess } = useOrder();

  const isfetching = isInFetch();

  if ((getLength() === 0 || isInProcess()) && !isfetching)
    return <Navigate to="/" replace />;
  return (
    <div className="place-type-container upper-container">
      {isfetching ? <Loader loading={isfetching} /> : <Outlet />}
    </div>
  );
}
